import { render, staticRenderFns } from "./ToastCopy.vue?vue&type=template&id=52e03136&scoped=true&"
import script from "./ToastCopy.vue?vue&type=script&lang=js&"
export * from "./ToastCopy.vue?vue&type=script&lang=js&"
import style0 from "./ToastCopy.vue?vue&type=style&index=0&id=52e03136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e03136",
  null
  
)

export default component.exports